module.exports = __webpack_public_path__ + "static/media/6H.a955a875.svg";